// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1DEqL","bigColWidth":"Table_bigColWidth__3chLH","biggerColWidth":"Table_biggerColWidth__2Ekp6","row":"Table_row__1c5RL","col":"Table_col__3MeOZ"};